import {
  AfterViewInit,
  Component,
  contentChild,
  ElementRef,
  input,
  signal,
} from '@angular/core';
import { BaseConfig } from '../common/config/config.adapter';

@Component({
  selector: 'lepi-accordion',
  standalone: true,
  imports: [],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.css',
})
export class Accordion extends BaseConfig implements AfterViewInit {
  headerContent = contentChild<ElementRef<HTMLElement>>('headerContent');

  title = input<string>('');
  default = input<'open' | 'close'>('open');
  open = signal(false);
  animated = signal(false);

  ngOnInit() {
    this.open.set(this.default() === 'open');
  }

  ngAfterViewInit() {
    // 첫 렌더링 이후에만 트랜지션 활성화
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.animated.set(true);
      });
    });
  }

  toggle() {
    this.open.set(!this.open());
  }

  slotClick(ev: any) {
    ev.stopPropagation();
  }
}
